<section class="horses-race-resulted" *ngIf="viewModel">
    <div class="result-container">
        <ul>
            <ms-resulted-placed-participants
                [isOptionBet]="isOptionBet"
                [participantOptionGroups]="viewModel.participantOptionGroups"
                [participants]="viewModel.placed"
                [prices]="prices"></ms-resulted-placed-participants>
            <ms-resulted-placed-participants
                [isOptionBet]="isOptionBet"
                [isFavourites]="true"
                [participantOptionGroups]="viewModel.participantOptionGroups"
                [participants]="viewModel.favorites"
                [prices]="prices"></ms-resulted-placed-participants>
            <ms-resulted-non-runner-participants [participants]="viewModel.nonRunners"></ms-resulted-non-runner-participants>
        </ul>
    </div>
    <div class="dividend-header" *ngIf="viewModel.hasDividends">{{ sitecore.horseRacing.raceResulted.Dividends }}</div>
    <div class="dividend-container" *ngIf="viewModel.hasDividends">
        <ng-container *ngFor="let dividend of viewModel.dividends">
            <div class="dividend" *ngIf="dividend.available">
                <div>{{ dividend.name }}</div>
                <div>{{ dividend.value || '-' }}</div>
            </div>
        </ng-container>
    </div>
</section>
